import { useContext } from 'react'

import { AttachmentListingsContext } from './constants'
import type { AttachmentListingsContextValue } from './types'

export const useAttachmentListingsContext =
  (): AttachmentListingsContextValue => {
    const context = useContext(AttachmentListingsContext)

    if (!context) {
      throw new Error(
        'useAttachmentListingsContext must be used within AttachmentListingsProvider'
      )
    }

    return context
  }
